import { render, staticRenderFns } from "./PolygonMenu.vue?vue&type=template&id=a0566ff6&scoped=true"
import script from "./PolygonMenu.vue?vue&type=script&lang=js"
export * from "./PolygonMenu.vue?vue&type=script&lang=js"
import style0 from "./PolygonMenu.vue?vue&type=style&index=0&id=a0566ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0566ff6",
  null
  
)

export default component.exports